import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createContext, useContext, useMemo } from 'react';
/**
 * Provides a way to store skip links
 */
export var SkipLinksDataContext = /*#__PURE__*/createContext([]);
var assignIndex = function assignIndex(num, arr) {
  if (!arr.includes(num)) {
    return num;
  }
  return assignIndex(num + 1, arr);
};
var sortSkipLinks = function sortSkipLinks(arr) {
  var customLinks = arr.filter(function (link) {
    return Number.isInteger(link.listIndex);
  });
  if (customLinks.length === 0) {
    return arr;
  }
  var usedIndexes = customLinks.map(function (a) {
    return a.listIndex;
  });
  var regularLinksWithIdx = arr.filter(function (link) {
    return link.listIndex === undefined;
  }).map(function (link, idx) {
    var listIndex = assignIndex(idx, usedIndexes);
    usedIndexes.push(listIndex);
    return _objectSpread(_objectSpread({}, link), {}, {
      listIndex: listIndex
    });
  });
  return [].concat(_toConsumableArray(customLinks), _toConsumableArray(regularLinksWithIdx)).sort(function (a, b) {
    return a.listIndex - b.listIndex;
  });
};
export var useSortedSkipLinks = function useSortedSkipLinks() {
  var skipLinksData = useContext(SkipLinksDataContext);
  return useMemo(function () {
    return sortSkipLinks(skipLinksData);
  }, [skipLinksData]);
};